import React from 'react';
import Seo from '../components/Seo';
import { getSiteSettings } from '../utils/cms';
import Hero from '../components/Hero';
import Collections from '../components/Collections';
import NewCollections from '../components/NewCollections';
import About from '../components/About';
import Gallery from '../components/Gallery';
import GoogleReviews from '../components/GoogleReviews';
import CustomerReferences from '../components/CustomerReferences';
import CTA from '../components/CTA';
import Contact from '../components/Contact';
import Partners from '../components/Partners';
import LocalSeoContent, { localFaqs } from '../components/LocalSeoContent';

const HomePage = () => {
  const settings = getSiteSettings();
  
  const siteUrl = 'https://fliesen-jarek.de';
  const localBusinessSchema = {
    '@type': 'HomeAndConstructionBusiness',
    '@id': `${siteUrl}/#business`,
    'name': 'Fliesen Jarek',
    'legalName': 'Jarek Jozwiak',
    'image': `${siteUrl}/images/projekte/neuneuneu/WhatsApp%20Image%202025-06-29%20at%2010.50.35%20(4).jpeg`,
    'logo': `${siteUrl}${settings.logo}`,
    'url': siteUrl,
    'telephone': settings.phone,
    'email': settings.email,
    'description': 'Persönlich geführter Fliesenlegerbetrieb in Cuxhaven für Badsanierung, Fliesenverlegung, Naturstein, Abdichtung und Reparaturen.',
    'priceRange': '€€',
    'address': {
      '@type': 'PostalAddress',
      'streetAddress': settings.address.street,
      'addressLocality': settings.address.city,
      'postalCode': settings.address.zip,
      'addressCountry': 'DE'
    },
    'areaServed': ['Cuxhaven', 'Otterndorf', 'Hemmoor', 'Bremerhaven', 'Stade'].map((name) => ({ '@type': 'City', name })),
    'openingHoursSpecification': [{
      '@type': 'OpeningHoursSpecification',
      'dayOfWeek': ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
      'opens': '08:00',
      'closes': '17:00'
    }],
    'sameAs': [
      'https://www.facebook.com/fliesenjarek',
      'https://www.instagram.com/fliesenjarek'
    ],
    'hasOfferCatalog': {
      '@type': 'OfferCatalog',
      'name': 'Fliesenarbeiten und Sanierung',
      'itemListElement': ['Badsanierung', 'Fliesenverlegung', 'Natursteinarbeiten', 'Nassraum-Abdichtung', 'Reparaturarbeiten'].map((name) => ({
        '@type': 'Offer',
        'itemOffered': { '@type': 'Service', name }
      }))
    }
  };

  const homePageSchema = {
    '@context': 'https://schema.org',
    '@graph': [
      localBusinessSchema,
      {
        '@type': 'WebSite',
        '@id': `${siteUrl}/#website`,
        'url': siteUrl,
        'name': 'Fliesen Jarek',
        'inLanguage': 'de-DE',
        'publisher': { '@id': `${siteUrl}/#business` }
      },
      {
        '@type': 'FAQPage',
        '@id': `${siteUrl}/#faq`,
        'mainEntity': localFaqs.map((faq) => ({
          '@type': 'Question',
          'name': faq.question,
          'acceptedAnswer': { '@type': 'Answer', 'text': faq.answer }
        }))
      }
    ]
  };

  return (
    <>
      <Seo schema={homePageSchema} />
      <Hero />
      <Gallery />
      <Collections />
      <NewCollections />
      <CustomerReferences />
      <GoogleReviews />
      <About />
      <CTA />
      <Contact />
      <LocalSeoContent />
      <Partners />
    </>
  );
};

export default HomePage;
